import { api } from "api/api";
import { AxiosError } from "axios";
import Setor from "model/administracao/cadastro/Setor";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";


export default class ItemAuditoriaService implements BaseServiceCadastros<ItemClasseAuditoria> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta, idConta?: number | null): Promise<Page> {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/itemAuditoria/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    consultar(id: number | string, idConta?: number | null): Promise<ItemClasseAuditoria> {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => {
            api
                .get(`/auditoria/app/item/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    incluir(model: ItemClasseAuditoria | FormData, idConta?: number | null): Promise<ItemClasseAuditoria> {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => { });
    }
    editar(model: ItemClasseAuditoria | FormData, idConta?: number | null): Promise<ItemClasseAuditoria> {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => { });
    }
    excluir(id: number | string, idConta?: number | null): Promise<void> {
        return new Promise((resolve, reject): void => { });
    }

    getRelatorioListagem(filter?: DataTableFilterMeta | null) {
        let url = `/itemAuditoria/report/listagem`;
        if (filter) {
            url += getFilters(filter)
        }
        return new Promise<string>((resolve, reject): void => {
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getSetoresDisponiveis() {
        return new Promise<Setor[]>((resolve, reject): void => {
            api
                .get(`/itemAuditoria/setoresDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getResultado(status: string): string {

        if (status === 'CONFORME') {
            return 'Conforme';
        } else if (status === 'PARCIAL') {
            return 'Parcial';
        } else if (status === 'NAO_CONFORME') {
            return 'Não Conforme';
        } else if (status === 'NAO_APLICAVEL') {
            return "Não aplicável";
        }
        return "";
    }

    getResultadoFilter() {
        return [
            { label: 'Conforme', value: 'C' },
            { label: 'Parcial', value: 'P' },
            { label: 'Não Conforme', value: 'N' },
            { label: 'Não Aplicável', value: 'NA' }
        ]
    }

    salvarItem(item: ItemClasseAuditoria) {

        return new Promise<ItemClasseAuditoria>((resolve, reject): void => {
            api
                .put(`/auditoria/app/itemAuditoria`, (item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    iniciarItemAuditoria(item: ItemClasseAuditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/itemAuditoria/app/iniciar`, JSON.stringify(item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    finalizarItemAuditoria(item: ItemClasseAuditoria) {
        return new Promise<Auditoria>((resolve, reject): void => {
            api
                .post(`/itemAuditoria/app/finalizar`, JSON.stringify(item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    marcarConforme(item: ItemClasseAuditoria) {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => {
            api
                .post(`/itemAuditoria/app/marcarConforme/${item.id}`, JSON.stringify(item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    marcarNaoConforme(item: ItemClasseAuditoria) {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => {
            api
                .post(`/itemAuditoria/app/marcarNaoConforme/${item.id}`, JSON.stringify(item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    marcarNaoAplicavel(item: ItemClasseAuditoria) {
        return new Promise<ItemClasseAuditoria>((resolve, reject): void => {
            api
                .post(`/itemAuditoria/app/marcarNaoAplicavel/${item.id}`, JSON.stringify(item))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}